var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfigSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.125 7.33333C10.918 7.33333 10.75 7.18399 10.75 6.99999V3.99999C10.75 2.16199 9.06775 0.666659 7 0.666659C4.93225 0.666659 3.25 2.16199 3.25 3.99999V6.99999C3.25 7.18399 3.082 7.33333 2.875 7.33333C2.668 7.33333 2.5 7.18399 2.5 6.99999V3.99999C2.5 1.79399 4.51825 -7.62939e-06 7 -7.62939e-06C9.48175 -7.62939e-06 11.5 1.79399 11.5 3.99999V6.99999C11.5 7.18399 11.332 7.33333 11.125 7.33333Z",
    fill: "#616161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 15.9999H1.75C0.92275 15.9999 0.25 15.4019 0.25 14.6665V7.99987C0.25 7.26454 0.92275 6.66654 1.75 6.66654H12.25C13.0773 6.66654 13.75 7.26454 13.75 7.99987V14.6665C13.75 15.4019 13.0773 15.9999 12.25 15.9999ZM1.75 7.33321C1.336 7.33321 1 7.63254 1 7.99987V14.6665C1 15.0339 1.336 15.3332 1.75 15.3332H12.25C12.664 15.3332 13 15.0339 13 14.6665V7.99987C13 7.63254 12.664 7.33321 12.25 7.33321H1.75Z",
    fill: "#616161"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigSvg);
export default __webpack_public_path__ + "static/media/config-svg.1d6cbda4.svg";
export { ForwardRef as ReactComponent };